
export const PROFILE = {
    name: "Georgie Recabo",
    fullName: "Georgie Mordeno Recabo",
    role: "Full Stack Developer",
    city: "Philippines",
    degree: "Bachelor's Degree",
    email: "artamay1@gmail.com",
    github: "https://github.com/grecabo123",
    linkedin: "https://www.linkedin.com/in/georgie-r-7795b61b7/",
};

export const NAV = [
    { id: "about", label: "About Me" },
    { id: "projects", label: "Projects" },
    { id: "tools", label: "Tools & Programming Language" },
];

export const ABOUT_TEXT =
    `I am a Senior Full Stack Developer, committed to building clean, maintainable, scalable, and high-quality software solutions that transform complex business requirements into efficient and reliable applications. I have extensive experience in database management, RESTful API development, third-party integrations, legacy system modernization, and performance optimization, with a strong focus on maintainability and scalability. I am also experienced in deploying and maintaining applications in Ubuntu and VPS environments, managing Git repositories, and applying modern development practices and technologies. Beyond technical implementation, I value teamwork, knowledge sharing, and ownership, consistently striving to deliver reliable solutions that enhance system performance and user experience.`;

export const EXPERIENCE = [
    {
        role: "Senior Software Developer",
        company: "Mapúa University",
        period: "Jul 2024 — Present",
        description:
            "Responsible for developing, enhancing, and maintaining applications to improve functionality, performance, and overall user experience. Leads the modernization of legacy code by implementing modern technologies and optimized server-side processes, resulting in more efficient data retrieval and improved application performance. Provides technical guidance to colleagues on effective Git practices and version control workflows.",
        stack: ["HTML5", "CSS3", "Bootstrap", "GitHub", "C#", "SQL", "Windows", "JavaScript"],
    },
    {
        role: "Senior Full Stack Developer",
        company: "ICargo Pacific Technologies",
        period: "Mar 2024 — Nov 2024",
        description:
            "Spearheaded the development of the **“Empowering Logistics & Cargo Business With Advanced Software Solutions System,”** taking ownership of the system’s architecture and technical implementation. Designed and optimized the database structure, integrated QR and barcode scanning capabilities, developed real-time parcel tracking mechanisms, and implemented third-party service integrations. Led the development of scalable and efficient solutions to streamline logistics operations, improve data processing, and enhance overall system performance and user experience.",
        stack: ["Laravel", "HTML5", "CSS3", "Bootstrap", "React", "npm", "GitHub", "MySQL", "JavaScript"],
    },
    {
        role: "Junior Developer",
        company: "iTECH-RAR Solutions, Inc.",
        period: "Jul 2023 — Dec 2023",
        description:
            "Contributed to the development and maintenance of a payroll system while supporting and managing five school systems. Developed system features, troubleshot technical issues, and promptly addressed client-reported concerns to ensure reliable system performance and continuous operation.",
        stack: ["Laravel", "HTML5", "CSS3", "Bootstrap", "GitHub", "Linux", "GitLab", "MySQL", "JavaScript"],
    },
    {
        role: "Software Developer",
        company: "Freelancer",
        period: "Jul 2022 — Apr 2024",
        description:
            "Conceptualized and developed a web application from the ground up based on client requirements. Translated business needs into functional features and delivered a customized solution that addressed client objectives while providing a reliable and user-friendly experience.",
        stack: ["Laravel", "HTML5", "CSS3", "Bootstrap", "React", "npm", "GitHub", "Linux", "MySQL", "JavaScript"],
    },
];

export const FACTS = [
    "Flexible and adapts easily to new environments, with strong problem-solving and logic-analysis skills.",
    "Good leadership skills, with the ability to guide and educate fellow developers.",
];

export const AWARDS = [
    {
        title: "Intermediate SQL for Data Scientists",
        link: "https://www.linkedin.com/learning/certificates/b946d5f491a6192f73cd3eba165f85daf95ee4b7639bf746244a689698704f57?u=89213594",
    },
    {
        title: "Advanced SQL: Logical Query Processing",
        link: "https://www.linkedin.com/learning/certificates/b946d5f491a6192f73cd3eba165f85daf95ee4b7639bf746244a689698704f57?u=89213594",
    },
    {
        title: "Improving Your Leadership Communications (2021)",
        link: "https://www.linkedin.com/learning/certificates/657ce4939921db0ec2ba1a15a52095e1f28a11d1f2aad6f2d2959c44e6e0c209?u=89213594",
    },
];

export const INTEREST_TEXT =
    "Outside of work, I spend a lot of free time researching the latest developments in web and game development. I also enjoy basketball, volleyball, and most outdoor activities.";

export const TESTIMONIALS = [
    {
        quote:
            "He was the one who helped me develop the UI/UX for the logistics system. I also supported him as a tester, and from my experience, I can see that he is capable of developing solutions for the system.",
        name: "Daryl Nicole",
        role: "Web Designer, ICargo Pacific Technology",
    },
    {
        quote:
            "Georgie picked up the logistics system's requirements fast and kept the database structure clean even as scope kept growing.",
        name: "Justin San",
        role: "CEO @ ICargo Pacific Technology",
    },
    {
        quote:
            "Reliable with deadlines and upfront about trade-offs early, which saved us from a few costly changes later.",
        name: "Anonymous",
        role: "Mapua University",
    },
  
    {
        quote:
            "Good at explaining technical trade-offs in plain terms, which made planning with the rest of the team much easier.",
        name: "Anonymous",
        role: "Mapua University",
    },
 
];

export const PROJECT_GROUPS = [
    {
        company: "Mapúa University",
        role: "Senior Software Developer",
        projects: [
            { type: "Web Based", title: "Mapúa University School System" },
            { type: "Web Based", title: "Mapúa University Innovation and Development Office for Career Advancement and Lifelong Learning" },
        ],
    },
    {
        company: "ICargo Pacific Technologies",
        role: "Full Stack Developer",
        projects: [
            { type: "Web Based", title: "Empowering Logistics & Cargo Business With Advanced Software Solutions System 2023" },
        ],
    },
    {
        company: "iTECH-RAR Solutions, Inc.",
        role: "Junior Developer",
        projects: [
            { type: "Web Based", title: "Bethany Christian School System in Gakkousoft" },
            { type: "Web Based", title: "Oneworld Montessori House School System in Gakkousoft" },
            { type: "Web Based", title: "Nissi Academy School System in Gakkousoft" },
            { type: "Web Based", title: "Notre Dame of Dadiangas University School System in Gakkousoft" },
            { type: "Web Based", title: "Bright Academy School System in Gakkousoft" },
            { type: "Web Based", title: "Mandaue Christian Schools School System in Gakkousoft" },
            { type: "Web Based", title: "Enterprise Resources Planning System (ERP)" },
            { type: "Web Based", title: "Web-Based DTR System with Face Recognition, Fingerprint Scanner, ID Scanner" },
        ],
    },
    {
        company: "Personal Projects",
        role: "Independent Work",
        projects: [
            { type: "Web Based", title: "Web Portal and Decision Support System for the Bureau of Fire Protection" },
            { type: "Web Based", title: "Web-Based Thesis & Research Archive — Father Saturnino Urios University" },
            { type: "Mobile 2D Game", title: "RPG 2D Game — Android, Falchion, built with Unity" },
            { type: "Web Based", title: "ANECO Chatbot — Consumer Complaint Management with Insights and Proactive Solutions" },
            { type: "Web Based", title: "Coconut Bidding System for Local Coconut Farmers, Caraga Region XIII" },
            { type: "Web Based", title: "Thesis Management System — Northwestern Mindanao State College of Science and Technology" },
            { type: "Web Based", title: "Enhancing Inventory System at JVV Marketing Corporation" },
            { type: "Web Based", title: "Enhancing Creativity Through AI — Auto-Generated Floral Design and Ordering System" },
            { type: "Web Based", title: "Web-Based Automated DTR & Payroll Management System" },
        ],
    },
];

export const TOOL_GROUPS = [
    { group: "Languages", items: ["JavaScript", "C#", "SQL","PHP"] },
    { group: "Frameworks & libraries", items: ["Laravel", "React", "Bootstrap"] },
    { group: "Markup & styling", items: ["HTML5", "CSS3"] },
    { group: "Version control", items: ["Git", "GitHub", "GitLab"] },
    { group: "Build & runtime", items: ["npm", "Node.js"] },
    { group: "Game development", items: ["Unity"] },
];

export const OS_LIST = [
    { name: "Ubuntu", detail: "Primary environment for VPS deployment and server management." },
    { name: "Linux", detail: "General development, scripting, and lightweight server work." },
    { name: "Windows", detail: "Local development, testing, and everyday productivity." },
];

export const TERMINAL_LINES = [
  { type: "prompt", text: "git pull origin main" },
  { type: "output", text: "Already up to date." },
  { type: "blank", text: "" },
  { type: "prompt", text: "npm run build" },
  { type: "success", text: "✓ build complete" },
  { type: "blank", text: "" },
  { type: "prompt", text: "sudo service apache2 restart" },
  { type: "success", text: "✓ Apache restarted successfully" },
];